<template>
  <!-- <b-container fluid> -->
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="/">BMCC Make-a-thon</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <!-- <b-nav-item href="#home" v-smooth-scroll>Home</b-nav-item> -->
            <li class="nav-item">
              <a href="#home" class="nav-link" v-smooth-scroll>Home</a>
            </li>
            <li class="nav-item">
              <a href="#software" class="nav-link" v-smooth-scroll>Software Architecture</a>
            </li>
            <li class="nav-item">
              <a href="#chatbot" class="nav-link" v-smooth-scroll>Chatbot</a>
            </li>
            <li class="nav-item">
              <a href="#about" class="nav-link" v-smooth-scroll>About</a>
            </li>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  <!-- </b-container> -->
</template>

<script>
export default {
}
</script>